import { render, staticRenderFns } from "./PublipostagesPercentage.vue?vue&type=template&id=05212588&scoped=true&"
import script from "./PublipostagesPercentage.vue?vue&type=script&lang=js&"
export * from "./PublipostagesPercentage.vue?vue&type=script&lang=js&"
import style0 from "./PublipostagesPercentage.vue?vue&type=style&index=0&id=05212588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05212588",
  null
  
)

export default component.exports